<script setup>
const props = defineProps({
  row: { type: Boolean, default: false },
  mobileCol: { type: Boolean, default: false },
  mobileRow: { type: Boolean, default: false },
  wrap: { type: Boolean, default: false },
  justify: {
    type: String, default: null, validator(value) {
      return ['start', 'end', 'center', 'between', 'around'].includes(value)
    }
  },
  mobileJustify: {
    type: String, default: null, validator(value) {
      return ['start', 'end', 'center', 'between', 'around'].includes(value)
    }
  },
  items: {
    type: String, default: null, validator(value) {
      return ['start', 'end', 'center', 'stretch'].includes(value)
    }
  },
  mobileItems: {
    type: String, default: null, validator(value) {
      return ['start', 'end', 'center', 'stretch'].includes(value)
    }
  },
  gap: { type: [Boolean, String], default: true },
})

const getClass = () => {
  const common = [
    'flex',
  ]
  if (props.gap === true) {
    common.push(`gap-4`)
  } else if (props.gap) {
    common.push(props.gap)
  }
  if (props.wrap) {
    common.push('flex-wrap')
  }

  let defaultJustify = 'start'
  let defaultItems = 'center'
  if (props.row) {
    if (props.mobileCol) {
      common.push(`flex-col md:flex-row`)
    } else {
      common.push('flex-row')
    }
  } else {
    if (props.mobileRow) {
      common.push(`flex-row md:flex-col flex-wrap`)
    } else {
      common.push('flex-col')
    }
    defaultItems = 'stretch'
  }
  if (props.mobileJustify) {
    common.push(`justify-${props.mobileJustify} md:justify-${props.justify || defaultJustify}`)
  } else {
    common.push(`justify-${props.justify || defaultJustify}`)
  }
  if (props.mobileItems) {
    common.push(`items-${props.mobileItems} md:items-${props.items || defaultItems}`)
  } else {
    common.push(`items-${props.items || defaultItems}`)
  }

  return [...common]
}
</script>

<template lang="pug">
div(:class="getClass()")
  slot
</template>